import { MoreHoriz } from '@mui/icons-material';
import { Box, IconButton, Paper, Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import { Message, ParticipantEntityType } from 'middleware-types';
import { RichTextDisplay } from '../../../ui/rich-text-editor/rich-text-display';
import { ReadReceipt } from './read-receipt';
import { EmblemAvatar } from 'components/ui/emblem/emblem-avatar';

interface ConversationMessageProps {
	message: Message;
}

export const ConversationMessage = ({ message }: ConversationMessageProps) => {
	if (message.creatorEntityType === ParticipantEntityType.System) {
		return (
			<Box textAlign="center" px={2}>
				<Typography variant="body2">{message.messageText}</Typography>
			</Box>
		);
	}

	const dateString = format(new Date(message.createdUtc), 'MMMM d, y h:mm a');
	return (
		<Stack p={2} spacing={2.5} component={Paper} elevation={1} borderRadius={0}>
			<Stack direction="row" spacing={1.5} alignItems="center">
				<EmblemAvatar emblem={message.creatorEmblem} size={32} />
				<Box flex={1}>
					<Typography variant="h6">{message.creatorEmblem.displayName}</Typography>
					<Typography variant="body2" color="neutral.600">
						{dateString}
					</Typography>
				</Box>
				<IconButton>
					<MoreHoriz />
				</IconButton>
			</Stack>
			<RichTextDisplay content={message.messageText} />
			<ReadReceipt message={message} />
		</Stack>
	);
};
